import React from "react";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

export default function TimeSelect({ value = "", onChange, className = "", compact = false, showClear = true }) {
  const [hour = "", minute = ""] = String(value || "").split(":");

  const update = (nextHour, nextMinute) => {
    if (!nextHour && !nextMinute) {
      onChange("");
      return;
    }
    onChange(`${nextHour || "00"}:${nextMinute || "00"}`);
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <select
        value={hour}
        onChange={(e) => update(e.target.value, minute)}
        className={`border rounded bg-transparent py-1 ${compact ? "px-1 text-sm" : "px-2"}`}
      >
        <option value="">시</option>
        {HOURS.map((item) => (
          <option key={item} value={item}>
            {item}시
          </option>
        ))}
      </select>
      <select
        value={minute}
        onChange={(e) => update(hour, e.target.value)}
        className={`border rounded bg-transparent py-1 ${compact ? "px-1 text-sm" : "px-2"}`}
      >
        <option value="">분</option>
        {MINUTES.map((item) => (
          <option key={item} value={item}>
            {item}분
          </option>
        ))}
      </select>
      {showClear && value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="rounded border px-2 py-1 text-sm text-gray-600 hover:bg-gray-100"
        >
          지움
        </button>
      )}
    </div>
  );
}
